import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Placeholder = () => {
    const location = useLocation();
    const pageName = location.pathname.replace('/', '').replace('-', ' ');

    return (
        <>
            <Header />
            <div className="main-container" style={{ textAlign: 'center', padding: '5rem 1rem' }}>
                <h1 style={{ textTransform: 'capitalize' }}>{pageName}</h1>
                <p>This page is under construction. Please check back later!</p>
            </div>
            <Footer />
        </>
    );
};

export default Placeholder;
